<template>
      <fiche-header :ressource="ressource"
                    @back="back"
                    @openAll="openAll"
                    @closeAll="closeAll">
      </fiche-header>
  <div class="fiche">
    <!-- Liste des sections de la fiche -->
    <v-col :class="isCardView ? 'col-7' : 'px-0'" v-if="isDisplayed('MANUAL_BILLING_DOCUMENT')">
        <slot name="section-manual-billing-document">
          <section-manual-billing-document ref="MANUAL_BILLING_DOCUMENT"
                                           id="MANUAL_BILLING_DOCUMENT"
                                           :extended="isExtended('MANUAL_BILLING_DOCUMENT')"
                                           :showButton="true"
                                           :autoSave="true"
                                           :readOnly="readOnly"
                                           :moduleId="moduleId"
                                           :searchText="searchText"
                                           :ressourceHeader="ressource"
                                           :fiche="fiche"
                                           :toggleResetEtablissementSelect="toggleResetEtablissementSelect"
                                           :manual-billing-document=selectedManualBillingDocument
                                           :route="route"
                                           :attribut="attribut"
                                           @extended="setExtended"
                                           @fullscreen="setFullscreen"
                                           @status="updateStatus"
                                           @updated="manualBillingDocumentUpdated"
                                           @selectItem = "selectItem">
          </section-manual-billing-document>
        </slot>
    </v-col>
  </div>
</template>
<script lang="ts">
import { defineComponent, type PropType } from "vue";
import FicheBase from '@/framework/base/components/FicheBase';
import Route from '@/extend/classes/Route';
import { CiRouter } from '@/framework/base/helpers/NavHelper'
import { Fiches } from '@/generated/classes/AppSchema';
import { Extended } from '@/framework/base/classes/Schema';
import ManualBillingDocument from '@/extend/classes/ManualBillingDocument';
import FicheHeader from '@/framework/base/components/FicheHeader.vue';
import { GenFiche, RessourceGenFiche } from '@/generated/ressources/generatedRessources';
import SectionManualBillingDocument from '@/extend/sections/SectionManualBillingDocumentExtend.vue';

export default defineComponent({
  extends: FicheBase,
  components: {
    SectionManualBillingDocument,
    FicheHeader,
  },

  props: {
    manualBillingDocument: {
      type: Object as PropType<ManualBillingDocument>,
    },
  },

  created (): void {
    this.addFiches(this.sections);
  },

  data() {
    return {
      moduleId: 0,
      fiche: Fiches.MANUAL_BILLING_DOCUMENT,
      sections: [
        'MANUAL_BILLING_DOCUMENT',
      ],

      toggleResetEtablissementSelect: false,
    }
  },

  computed: {
    ressource () {
      return RessourceGenFiche(GenFiche.FICHE_MANUAL_BILLING_DOCUMENT);
    },

    selectedManualBillingDocument (): ManualBillingDocument {
      return this.manualBillingDocument
    },
  },
  methods: {
    ficheMounted () {
      this.onShowSectionChanged();
      this.setFocus();
    },

    setFocus (): void {
      if (this.isMounted) {
        let res = false;
        let first = '';
        const route = CiRouter.getRoute();
        const notifSection = route ? route.section : '';
        this.sections.forEach(section => {
          // @ts-expect-error : generated method
          if (this.isDisplayed(section) && this.$refs[section] && this.$refs[section].allReadOnly && this.$refs[section].setFocus) {
            if (notifSection == section) {
              // @ts-expect-error : generated method
              this.$refs[section].setFocus(route);
              res = true;
            } else if (first == '') {
              first = section;
            }
          }
        })
        if (!res && first != '' && this.$refs[first]) {
          // @ts-expect-error : generated method
          this.$refs[first].setFocus(route);
        }
      }
    },

    // eslint-disable-next-line
    manualBillingDocumentUpdated (manualBillingDocument: ManualBillingDocument) {
    // To implement
    },

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    isDisplayed (value: string): boolean {
      if ((!this.manualBillingDocument || this.manualBillingDocument.id < 0) && value == 'MANUAL_BILLING_DOCUMENT') {
        this.setExtended(new Extended('MANUAL_BILLING_DOCUMENT', this.fiche, true));
      }
      return true;
    }
  }
})
</script>
